<template>
  <div class="company-certification">
    <div class="company-certification-title">
      {{ $t('registration.sp.freelancer.company.certification.title') }}
    </div>
    <div class="company-certification-title-comment">
      {{ $t('registration.sp.freelancer.company.certification.title.comment') }}
    </div>
    <div class="company-certification-sub-title">
      {{ $t('registration.sp.freelancer.company.certification.sub.title.prefix') }}
      <span class="sub-title-blue">
        {{ $t('registration.sp.freelancer.company.certification.sub.title.blue.part') }}
      </span>
      {{ $t('registration.sp.freelancer.company.certification.sub.title.suffix') }}
    </div>
    <div class="sub-title-comment">
      {{ $t('registration.sp.freelancer.company.certification.sub.title.comment') }}
    </div>
    <company-certification-form
      @changed="formChanged"
      @onIpAddressChanged="onIpAddressChanged"
      @onRecommendationsChanged="onRecommendationsChanged"
      @onSocialNetworkChanged="onSocialNetworkChanged"
    >
    </company-certification-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CompanyCertificationForm from '@/components/spFreelancerRegistration/CompanyCertificationForm.vue';
import {
  CHANGE_SP_FREELANCER_COMPANY_CERTIFICATION,
  CHANGE_SP_FREELANCER_IP_ADDRESS_INFO,
  CHANGE_SP_FREELANCER_RECOMMENDATION_INFO,
  CHANGE_SP_FREELANCER_SOCIAL_NETWORK_LINK_INFO,
} from '@/store/spFreelancerRegistration/actionTypes';

export default {
  name: 'CompanyCertification',
  components: {
    CompanyCertificationForm,
  },
  computed: {
    ...mapGetters([
      'spFreelancerRegistrationCompanyCertificationInfo',
      'spFreelancerRegistrationCompanyIpAddressInfo',
      'spFreelancerRegistrationCompanyRecommendationInfo',
      'spFreelancerRegistrationCompanySocialNetworkLinkInfo',
    ]),
  },
  methods: {
    formChanged(data) {
      this.$store.dispatch(CHANGE_SP_FREELANCER_COMPANY_CERTIFICATION, data);
    },
    async onIpAddressChanged(data) {
      await this.$store.dispatch(CHANGE_SP_FREELANCER_IP_ADDRESS_INFO, data);
    },
    async onRecommendationsChanged(data) {
      await this.$store.dispatch(CHANGE_SP_FREELANCER_RECOMMENDATION_INFO, data);
    },
    async onSocialNetworkChanged(data) {
      await this.$store.dispatch(CHANGE_SP_FREELANCER_SOCIAL_NETWORK_LINK_INFO, data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.company-certification {
  border-radius: $radius-sm;
  background-color: $white;
  padding: rem(40) rem(80) rem(35);
  box-shadow: 0 0 rem(4) 0 rgba(14, 31, 51, 0.13);
  flex: 0.7;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.company-certification-title {
  color: $auth-text-primary;
  font-family: $font-family-medium;
  font-size: rem(20);
  font-weight: 500;
  letter-spacing: 0;
  line-height: rem(24);
  padding-bottom: rem(4);
}

.company-certification-title-comment {
  height: rem(16);
  color: $auth-text-muted;
  font-family: $font-family-regular;
  font-size: rem(14);
  letter-spacing: 0;
  line-height: rem(16);
  text-align: center;
  padding-bottom: rem(44);
}

.company-certification-sub-title {
  height: rem(18);
  color: $auth-text-primary;
  font-family: $font-family-regular;
  font-size: rem(14);
  letter-spacing: 0;
  line-height: rem(18);
  .sub-title-blue {
    color: $auth-brand;
  }
}

.sub-title-comment {
  height: rem(18);
  color: $auth-text-muted;
  font-family: $font-family-regular;
  font-size: rem(14);
  letter-spacing: 0;
  line-height: rem(18);
  margin-bottom: rem(32);
}
</style>
